/**
 * SEO 配置 - chat (Русский)
 */

export default {
    chat: {
        title: 'ИИ-чат - Мультимодельный ассистент | WeryAI',
        description:
            'Общайтесь с лучшими моделями ИИ на WeryAI. Сравнивайте ответы бок о бок в нескольких окнах. Создавайте изображения, видео и музыку в едином рабочем пространстве.',
        keywords:
            'ИИ-чат, ИИ-ассистент, мультимодельный чат, ИИ-чатбот, сравнение моделей ИИ, чат бок о бок, альтернатива GPT, рабочее пространство ИИ, WeryAI',
        og_title: 'ИИ-чат - Мультимодельный ассистент | WeryAI',
        og_description:
            'Общайтесь с лучшими моделями ИИ и сравнивайте ответы бок о бок. Создавайте изображения, видео и другое. Попробуйте бесплатно на WeryAI.',
        twitter_title: 'ИИ-чат - Мультимодельный ассистент | WeryAI',
        twitter_description:
            'Общайтесь с лучшими моделями ИИ и сравнивайте ответы бок о бок. Создавайте изображения, видео и другое. Попробуйте бесплатно на WeryAI.',
    },
}
